module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06c87997!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/Loading.vue
// module id = 357
// module chunks = 1